import i18n from 'i18nextInstance';

export const HEADERS = [{
    key: 'doctor_last_name',
    label: i18n.t('Apellido')
}, {
    key: 'doctor_first_name',
    label: i18n.t('Nombre')
}, {
    key: 'total',
    label: i18n.t('Total')
}, {
    key: 'oncourse',
    label: i18n.t('En curso')
}, {
    key: 'reviewed',
    label: i18n.t('En revisión')
}, {
    key: 'accepted',
    label: i18n.t('Aceptados')
}, {
    key: 'rejected',
    label: i18n.t('Rechazados')
}, {
    key: 'with_certificate',
    label: i18n.t('C/Cert.')
}, {
    key: 'without_certificate',
    label: i18n.t('S/Cert.')
}];
